import React, { useState, useEffect, useRef } from "react";
import Papa from "papaparse"; // Install with `npm install papaparse`
import {instance, instance2} from '../../utils/axiosInstance'
import DatePicker from "react-datepicker";
import CalendarIcon from "../../img/calendaricon.svg";
import { useNavigate, useLocation } from 'react-router-dom'
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { ReactComponent as BackButton } from "../../img/bacbuttonicon.svg";
import { formatNumber } from "../../numberingformat"; // Ensure formatNumber works for formatting
import Float from "src/components/login/float";


export default function UploadResep() {
  
const locationState = useLocation();
const dishId = locationState?.state?.newDishId;
const passedDishName = locationState?.state?.newDishName;


    const [newRecipeData, setNewRecipeData] = useState({
      note: "", // Initialize as an empty string
    });
    const navigate = useNavigate()
  const [username, setUsername] = useState("");
  const [formData, setFormData] = useState({
    id: "",
  });
  const [uploadedData, setUploadedData] = useState([]);
  const [validationResults, setValidationResults] = useState({});
  const [loadingValidation, setLoadingValidation] = useState(false);
  const [csvContent, setCsvContent] = useState("");
    const [dish, setDish] = useState([]); // Storage locations
    const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
      const [searchTerm, setSearchTerm] = useState("");
  
    const [selectedDate, setSelectedDate] = useState(new Date());
      const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null); // Ref to track dropdown
    const [ingredients, setIngredients] = useState([]);

    useEffect(() => {
      const fetchIngredients = async () => {
        try {
          const response = await instance2.get("/ingredient_master");
          setIngredients(response.data);
        } catch (error) {
          console.error("Failed to fetch ingredients", error);
        }
      };
    
      fetchIngredients();
    }, []);
    
  useEffect(() => {
    const storedUsername = localStorage.getItem("userAuthentication") || "Guest";
    setUsername(storedUsername);
  }, []);

  
    const CustomInput = React.forwardRef(({ onClick, isOpen }, ref) => (
        <button
          className="flex items-center justify-between w-full px-4 py-2 border-none rounded-[15px] bg-white"
          onClick={onClick}
          ref={ref}
          type="button"
        >
          {/* Left Section: Calendar Icon */}
          <div className="flex items-center gap-2">
          <img src={CalendarIcon} alt="Calendar" className="h-5 w-5 text-gray-500" />
      
      {/* Separator */}
      <div className="w-px h-5 bg-gray-300 mx-1 me-3"></div>
            <span>
              {new Date(selectedDate).toLocaleDateString("id-ID", {
                year: "numeric",
                month: "long",
                day: "2-digit",
              })}
            </span>
          </div>
      
          {/* Right Section: Rotating Arrow */}
          <div
          className={`text-black font-semibold transform transition-transform duration-500 ease-in-out ps-4 ${
            isOpen ? "rotate-180" : "rotate-0"
          }`}
        >
            ▼
          </div>
        </button>
      ));


    const filteredDish = dish.filter((dish) =>
      dishId? dish.id === parseInt(dishId) : 
      dish.name.toLowerCase().includes(searchTerm.toLowerCase())
      );

      useEffect(() => {
        const fetchDish = async () => {
          try {
            const response = await instance2.get("dishes");
            const locationData = response.data;
      
            const mapped = locationData.map((loc) => ({
              id: loc.id,
              name: loc.dish_name,
            }));
      
            setDish(mapped);
      
            // ✅ Pre-select the newly added dish if passed via navigation
            if (dishId && passedDishName) {
              setFormData({ location_id: dishId });
              setSearchTerm(passedDishName);
            }
          } catch (err) {
            console.error("Failed to fetch locations", err);
            setError(err.response?.data?.message || "Failed to fetch storage locations");
          } finally {
            setLoading(false);
          }
        };
      
        fetchDish();
      }, []);
      
      

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: async (results) => {
          setUploadedData(results.data);
          console.log("file", results.data)
          await validateIngredients(results.data);
        },
        error: (error) => {
          console.error("Error parsing CSV:", error);
        },
      });
    }
  };

  const validateIngredients = async (data) => {
    setLoadingValidation(true);

    const results = {};
    for (const row of data) {
      const ingredientName = row["Bahan Baku"] || row.bahan_baku;
      if (ingredientName) {
        try {
          const response = await instance2.get(
            `/ingredient/name/${encodeURIComponent(ingredientName)}`
          );
          const status =
          response.data[0].search_ingredient  === "OK"
              ? "OK"
              : "INVALID";
          results[ingredientName] = status;
          console.log("status", response)
          console.log("status1", response.data[0])
        } catch (error) {
          console.error(`Error validating ingredient ${ingredientName}:`, error);
          results[ingredientName] = "INVALID";
        }
      }
    }

    setValidationResults(results);
    setLoadingValidation(false);
  };

const postdata = async () => {
  const selectedDishId = dishId ? dishId : formData.id;

  if (!selectedDishId) {
    alert("Please ensure all fields are filled and a CSV file is uploaded.");
    return;
  }

  try {
    const fileInput = document.querySelector('input[type="file"]');
    const csvFile = fileInput?.files?.[0];

    if (!csvFile) {
      alert("Please upload a CSV file.");
      return;
    }

    // Prepare and send CSV upload
    const formDataToSend = new FormData();
    formDataToSend.append("id", selectedDishId);
    formDataToSend.append("admin_id", username);
    formDataToSend.append("fileUpload", csvFile);

    const response = await instance2.post("save_upload_recipe", formDataToSend, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    console.log("dishid", newRecipeData.note)
    if (response.status === "OK") {
      // ✅ After successful CSV upload, post the recipe step separately
      await instance2.post(`recipe_step/${selectedDishId}`, {
        step: newRecipeData.note,
      });

      alert("Data successfully posted!");
      navigate("/inputmenu");
    } else {
      alert("Failed to post data. Please try again.");
    }
  } catch (error) {
    console.error("Error posting data:", error);
    alert("An error occurred while posting data.");
  }
};

  
  const handleGenerateExampleCsv = () => {
    if (!ingredients || ingredients.length === 0) {
      alert("Data bahan baku belum tersedia.");
      return;
    }
  
    // Sort ingredients alphabetically by ingredient_name
    const sortedIngredients = [...ingredients].sort((a, b) =>
      a.ingredient_name.localeCompare(b.ingredient_name)
    );
  
    const csvHeader = "No,Bahan Baku,Jumlah,uoq\n";
    const csvRows = sortedIngredients.map((item, index) =>
      [
        index + 1,
        item.ingredient_name || "-",
        "", // Let 'harga' be empty for user to fill in manually
        item.uoq_name || "-"
      ].join(",")
    );
  
    const csvData = csvHeader + csvRows.join("\n");
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "Contoh_Resep.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  
  

  const handleDownloadCsv = () => {
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "validated_data.csv");
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Check if all data is valid
  const isAllValid = () =>
    uploadedData.every((row) => {
      const ingredientName = row["Bahan Baku"] || row.bahan_baku;
      return validationResults[ingredientName] === "OK";
    });

    const renderedRowCount = uploadedData.filter((row) => {
      const jumlah = row.jumlah || row["Jumlah"];
      return jumlah && !isNaN(jumlah) && Number(jumlah) !== 0;
    }).length;
    
  return (
    <div className="max-w-2xl mx-auto p-4 h-full">
    <div className="flex flex-row gap-4 items-center">
                          <div className="bg-white p-2 rounded-full cursor-pointer"
                              onClick={() => window.history.back()}>
                          <BackButton 
                          className="rotate-180 text-black" />
                          </div>
        <h1 className="block text-black text-xl sm:text-2xl my-2 font-medium">Upload CSV Resep</h1>
        </div>

        {/* <div className="flex flex-row gap-4 items-center py-4 justify-between">
        <div className="flex flex-row gap-4 items-center py-4">
        <div className="">Tanggal</div>
    <DatePicker
    selected={selectedDate}
    onChange={(date) => setSelectedDate(date)}
    dateFormat="yyyy-MM-dd"
    filterDate={(date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6;
    }}
    onCalendarOpen={() => setIsOpen(true)}
    onCalendarClose={() => setIsOpen(false)}
    customInput={<CustomInput isOpen={isOpen} />}
    />
    </div>
    </div> */}
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <>
          {/* Location ID */}
          <div className="mb-4 relative" ref={dropdownRef}>
            <label className="block text-gray-700 mb-2">Masakan</label>
            <div className="relative">
              <input
                type="text"
                placeholder="Pilih masakan"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onFocus={() => setIsDropdownOpen(true)}
                className="w-full px-3 border-none rounded-full bg-white text-xs py-4 focus:outline-none"
              />
              {/* Dropdown Arrow */}
              <div
                className="absolute inset-y-0 right-3 flex items-center cursor-pointer"
                onClick={() => setIsDropdownOpen((prev) => !prev)}
              >
                <svg
                  className={`w-4 h-4 transition-transform ${
                    isDropdownOpen ? "rotate-180" : "rotate-0"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>
            {isDropdownOpen && (
              <div className="absolute z-10 bg-white border rounded-lg w-full max-h-40 overflow-y-auto shadow-lg mt-1">
                {filteredDish.length > 0 ? (
                  filteredDish.map((dish) => (
                    <div
                      key={dish.id}
                      className="px-4 py-2 text-sm cursor-pointer hover:bg-gray-100"
                      onClick={() => {
                        setFormData({ ...formData, id: dish.id });
                        setSearchTerm(dish.name);
                        setIsDropdownOpen(false);
                      }}
                    >
                      {dish.name}
                    </div>
                  ))
                ) : (
                  <div className="px-4 py-2 text-sm text-gray-500">
                    No Dish found
                  </div>
                )}
              </div>
            )}
          </div>
        </>
      )}

      {/* Generate Example CSV */}
      <div className="mb-4">
        <button
          onClick={handleGenerateExampleCsv}
          className="px-4 py-2 bg-oren-no text-white rounded hover:bg-oren-hover"
        >
          Download Contoh Resep
        </button>
      </div>
      
      {/* File Upload */}
      <div className="mb-4">
        <label className="block text-gray-700 mb-2">Upload Resep</label>
        <input
          type="file"
          accept=".csv"
          onChange={handleFileUpload}
          className="block w-full px-3 py-2 border border-gray-300 rounded-md"
        />
      </div>

      {/* Display Uploaded Data */}
      {uploadedData.length > 0 && (
  <div className="flex flex-col mb-4">
    <h2 className="text-lg font-semibold mb-2">Hasil Upload CSV Data</h2>
    <table className="w-full border-collapse border-b border-gray-300">
      <thead>
        <tr className="bg-white">
          <th className="border-b border-gray-300 px-4 py-2 rounded-tl-[15px]">No.</th>
          <th className="border-b border-gray-300 px-4 py-2 text-left">Bahan Baku</th>
          <th className="border-b border-gray-300 px-4 py-2 text-right">Jumlah</th>
          <th className="border-b border-gray-300 px-4 py-2 text-center">Unit</th>
          <th className="border-b border-gray-300 px-4 py-2 rounded-tr-[15px]">Status</th>
        </tr>
      </thead>
      <tbody>
     {(() => {
       let rowNumber = 1;
       return uploadedData.map((row, index) => {
         const ingredientName = row["Bahan Baku"] || row.bahan_baku;
         const status = validationResults[ingredientName];
         const jumlah = row["Jumlah"] || row.jumlah;
     
         // Skip invalid rows
         if (!jumlah || isNaN(jumlah) || Number(jumlah) === 0 || Float(jumlah)) return null;
     
         // Render only valid rows and increase counter
         return (
           <tr key={index} className="odd:bg-gray-100 even:bg-white">
             <td className="w-[25px] lg:w-[50px] border-b border-gray-300 px-4 py-2 text-sm">
               {rowNumber++}
             </td>
             <td className="border-b border-gray-300 px-4 py-2 text-sm">{ingredientName || "-"}</td>
             <td className="border-b border-gray-300 px-4 py-2 text-sm text-right">{formatNumber(jumlah) || "-"}</td>
             <td className="border-b border-gray-300 px-4 py-2 text-sm text-center">{row.uoq}</td>
             <td className="border-b border-gray-300 px-4 py-2 text-sm">
               {status === "OK" && <span className="text-green-500">Valid</span>}
               {status === "INVALID" && <span className="text-red-500">Invalid</span>}
               {!status && <span className="text-gray-500">Pending Validation</span>}
             </td>
           </tr>
         );
       });
     })()}

      </tbody>
    </table>
    {/* ReactQuill Section */}
    <div className="flex-1 mb-4 mt-4">
      <ReactQuill
        value={newRecipeData.note}
        onChange={(value) =>
          setNewRecipeData((prev) => ({ ...prev, note: value }))
        }
        className="h-[200px] bg-white"
      />
      <style>
        {`
          .ql-container {
            background-color: white !important;
          }
        `}
      </style>
    </div>

    {/* Generate and Download CSV */}
    <div className="flex flex-col gap-4 mt-14">
   <button
  onClick={postdata}
  className={`px-4 py-2 ${
    isAllValid() && formData.id && uploadedData.length > 0 && renderedRowCount > 0
      ? "bg-blue-500 hover:bg-blue-600"
      : "bg-gray-400 cursor-not-allowed"
  } text-white rounded-[15px]`}
  disabled={!(
    isAllValid() &&
    formData.id &&
    uploadedData.length > 0 &&
    renderedRowCount > 0
  )}
>
  SIMPAN
</button>


    </div>
  </div>
)}

    </div>
  );
}
